import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { NVDBaseMetrics } from '../../../../shared/vulns/Drawer';
import * as PackageInventoryStore from '../../../../../redux/packageInventory';
import { CVSSMetric } from '../../../../../../shared/vulns/types';

/**
 * Container component for the VulnerabilityDrawerNVDBaseMetrics
 */
const PackageVersionVulnerabilityDrawerNVDBaseMetrics: VoidFunctionComponent = () => {
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetSelectedVuln);
  const metrics: CVSSMetric[] = useSelector(PackageInventoryStore.selectors.getSelectedVulnNVDBaseMetrics);
  return (
    <NVDBaseMetrics
      isLoading={isLoading}
      metrics={metrics}
    />
  );
};

export default PackageVersionVulnerabilityDrawerNVDBaseMetrics;
